import { State } from './../state';
import { IMenuState } from './state';
import { getStoreAccessors } from 'typesafe-vuex';

export const getters = {
    menu: (state: IMenuState) => state.menu,
    menuCategories: (state: IMenuState) => state.categories,
    menuItems: (state: IMenuState) => state.items,
    menuOneItem: (state: IMenuState) => (itemId: number) => {
        const filteredItems = state.items.filter((menuItem) => menuItem.id === itemId);
        if (filteredItems.length > 0) {
            return { ...filteredItems[0] };
        }
    },
    menuCounter: (state: IMenuState) => state.counter,
};

export const { read } = getStoreAccessors<IMenuState, State>('');

export const readMenu = read(getters.menu);
export const readMenuCategories = read(getters.menuCategories);
export const readMenuItems = read(getters.menuItems);
export const readMenuOneItem = read(getters.menuOneItem);
export const readMenuCounter = read(getters.menuCounter);

